/**
 * @desc 获取问卷的回答历史时间线
 * @author Kody
 * @date 2019-11-14
 * @see http://api.umucdn.cn/project/51/interface/api/2801
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface ISubmitItem {
    id: string;
    user_id: string;
    session_id: string;
    student_id: string;
    create_time: string;
    update_time: string;
    status: string;
    submit_num: number;
    submit_type: '0' | '1'; // 是否逐题模式下提交
    is_anonymous: '0' | '1'; // 是否匿名
}

export const getSurveySubmitList = (elementId: number): Promise<IResponse<ISubmitItem>> => {
    return fetchData(Api.GET_SURVVEY_SUBMIT_LIST, { element_id: elementId }).then((res: IResponse<ISubmitItem>) => {
        return res;
    });
};
